module.exports = __webpack_public_path__ + "assets/img/jonas.b4f2dcc6.jpg";